import { render, staticRenderFns } from "./ParticipantsList.vue?vue&type=template&id=3c0c4701&scoped=true&"
import script from "./ParticipantsList.vue?vue&type=script&lang=ts&"
export * from "./ParticipantsList.vue?vue&type=script&lang=ts&"
import style0 from "./ParticipantsList.vue?vue&type=style&index=0&id=3c0c4701&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0c4701",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCardText,VDataTable})
